import { actionTypes } from 'store/utils';

export const types = {
  ...actionTypes('GET_FORM_DATA'),
  ...actionTypes('GET_TASK_DATA'),
  ...actionTypes('GET_ACTIONS_ADMIN'),
  ...actionTypes('QUERY_TASKS'),
  ...actionTypes('GET_FORM_UPLOADS'),
  ...actionTypes('GET_PROCESS_INSTANCES'),
  ...actionTypes('OPEN_UPLOADED_FILE'),
  ...actionTypes('DOWNLOAD_UPLOADED_FILE'),
  ...actionTypes('FETCH_PROCESS_SAYT'),
  ...actionTypes('FIND_KEYWORDS'), 
  ...actionTypes('LIST_APPLICATIONS_ADMIN'), // For /admin/process-instances-apptrack
  ...actionTypes('GET_PROCESS_VARIABLES_ADMIN'),
  ...actionTypes('GET_COUNTRY_LOCALS_ADMIN'),
  ...actionTypes('UPDATE_LOCAL_ADMIN'),
  ...actionTypes('GET_ALL_USERS_DATA_ADMIN'),
  ...actionTypes('GET_ALL_GROUPS_ADMIN'),
  ...actionTypes('GET_ALL_APP_CONFIGURATIONS_ADMIN'),
  ...actionTypes('GET_SELECTED_APP_CONFIGURATION_ADMIN'),
  ...actionTypes('CREATE_USER_ADMIN'),
  ...actionTypes('CREATE_GROUP_ADMIN'),
  ...actionTypes('UPDATE_USER_ADMIN'),
  ...actionTypes('ADD_USER_INFO_ADMIN'),
  ...actionTypes('UPDATE_USER_GROUP_ADMIN'),
  ...actionTypes('CLEAR_USER_GROUPS'),
  ...actionTypes('DELETE_USER_ADMIN'),
  ...actionTypes('DELETE_GROUP_ADMIN'),
  ...actionTypes('GET_USER_DATA_ADMIN'),
  ...actionTypes('GET_GROUP_DATA_ADMIN'),
  ...actionTypes('UPDATE_ADMIN_FIELD'),
  ...actionTypes('UPDATE_ADMIN_TABLE_FIELD'),
  ...actionTypes('UPDATE_LANG_CONFIG'),
  ...actionTypes('UPDATE_APP_CONFIG'),
  ...actionTypes('APP_DETAILS'), // For /admin/process-instance-apptrack-detailed/{procInstId}
  ...actionTypes('UPDATE_PROCESS_ADMIN'), // For /admin/update-process-instance/{procInstId} (when implemented)
  ...actionTypes('CANCEL_PROCESS'), // For /admin/cancel-process-instance/{procInstId}
  ...actionTypes('ACTIVE_TASK_NAMES'), // For /admin/all-active-task-names
}